// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","495":"feed","594":"about"}[chunkId] + "." + {"353":"ceac591c","495":"5c558738","594":"96809d91"}[chunkId] + ".js";
};